module.exports = __webpack_public_path__ + "static/MainLogo-03-dbd0eadbaf986667109ab1124bc747f8.png";